import { render } from "./hostCard.vue?vue&type=template&id=73156975"
import script from "./hostCard.vue?vue&type=script&lang=js"
export * from "./hostCard.vue?vue&type=script&lang=js"
script.render = render

export default script